import { LOAD_CATEGORIES, SELECT_CATEGORY, CLEAN_SELECTED_CATEGORY } from "./actionTypes";

export const loadCategories = categories => ({
    type: LOAD_CATEGORIES,
    categories
});

export const chooseCategory = category => ({
    type: SELECT_CATEGORY,
    category
});

export const cleanCategory = () => ({
    type: CLEAN_SELECTED_CATEGORY
});